import React from 'react';
import { createPortal } from 'react-dom';
import { Building2, Loader2, X } from 'lucide-react';
import { CxEmailSendCompanyRow } from '../../customer-experience/components/CxEmailSendMailModal';
import '../../customer-experience/components/CxEmailTemplateModal.css';
import '../../customer-experience/components/CxEmailSendMailModal.css';
import './EmailNotificationsConfigPage.css';

const GENERAL_COD = '__geral__';

export function EmailScopeConfigModal({
  open,
  onClose,
  emailScope,
  generalRow,
  generalBaseline,
  onGeneralChange,
  onGeneralTest,
  onGeneralSendTest,
  companyRows,
  companyBaselines,
  companyLoading,
  expandedCodigos,
  onToggleExpanded,
  onCompanyChange,
  onCompanyTest,
  onCompanySendTest,
  testing,
  sending,
}) {
  if (!open) return null;

  return createPortal(
    <div className="modal-overlay enotif-scope-overlay" role="presentation" onClick={onClose}>
      <div
        className="cx-email-modal cx-email-send-modal enotif-scope-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="enotif-scope-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="cx-email-send-header">
          <h2 id="enotif-scope-title" className="cx-email-send-title">
            {emailScope === 'geral' ? 'E-mail geral de envio' : 'E-mail por empresa'}
          </h2>
          <button type="button" className="cx-email-send-close" onClick={onClose} aria-label="Fechar">
            <X size={18} strokeWidth={2} />
          </button>
        </header>

        <div className="cx-email-modal-body">
          {emailScope === 'geral' ? (
            <div className="cx-email-send-scroll enotif-scope-modal-scroll">
              <div className="cx-email-send-list enotif-general-list enotif-general-list--modal">
                <CxEmailSendCompanyRow
                  row={generalRow}
                  baseline={generalBaseline}
                  expanded
                  hideHead
                  showSenderName={false}
                  showFromEmail={false}
                  onToggle={() => {}}
                  onChange={(_, patch) => onGeneralChange(patch)}
                  onTest={onGeneralTest}
                  onSendTest={onGeneralSendTest}
                  testing={testing}
                  sending={sending}
                />
              </div>
            </div>
          ) : (
            <div className="cx-email-send-scroll enotif-scope-modal-scroll">
              <p className="cx-email-send-intro">
                Defina e-mail de autenticação, remetente (De), nome do perfil, senha, servidor e porta por empresa. Use os testes antes de salvar.
              </p>
              {companyLoading ? (
                <div className="cx-email-send-loading">
                  <Loader2 size={22} className="pcs2-spin" aria-hidden />
                  Carregando empresas…
                </div>
              ) : companyRows.length === 0 ? (
                <div className="cx-email-send-empty">
                  <Building2 size={24} strokeWidth={1.5} aria-hidden />
                  Nenhuma empresa ativa encontrada.
                </div>
              ) : (
                <div className="cx-email-send-list">
                  {companyRows.map((row) => (
                    <CxEmailSendCompanyRow
                      key={row.codigo}
                      row={row}
                      baseline={companyBaselines[row.codigo]}
                      expanded={expandedCodigos.has(row.codigo)}
                      onToggle={onToggleExpanded}
                      onChange={onCompanyChange}
                      onTest={onCompanyTest}
                      onSendTest={onCompanySendTest}
                      testing={testing}
                      sending={sending}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <footer className="cx-email-modal-footer enotif-scope-modal-footer">
          <span aria-hidden="true" />
          <div className="cx-email-modal-footer-actions">
            <button type="button" className="cx-email-btn cx-email-btn--primary" onClick={onClose}>
              Fechar
            </button>
          </div>
        </footer>
      </div>
    </div>,
    document.body
  );
}

export { GENERAL_COD };
